import karlPic from "@/public/images/artists/karl.jpg";
import { Artist } from "@/types/types";

export const karl = {
  id: "280",
  name: "Karl",
  image: karlPic,
  description: `Karl's voice is sharp and driving, with a cool-toned bite that carries well across different rock styles.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fkarl-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Rock", "Punk", "Pop", "Gritty", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 67,
      },
      sweetSpot: 61,
    },
  },
} satisfies Artist;
